import { es_US } from '@docupet/component-library';

export default {
  ...es_US,
  components: {
    removeBundleItemConfirmation: {
      title: '¿Estás seguro de que quieres eliminar este artículo de tu canasta?',
      message: 'Esto eliminará todos los elementos asociados {petName} el paquete de identificación de mascotas.',
      confirmButtonText: 'Sí, elimine el elemento',
      cancelButtonText: 'No, mantenga este artículo',
    },
    discount: {
      notApplyTip: 'Los códigos de promoción no se aplican a tarifas de licencias para mascotas, cargos por pagos atrasados, etiquetas de reemplazo para mascotas, artículos en paquete o artículos de oferta específicos.'
    },
  },
};
